module.exports = __webpack_public_path__ + "static/media/user.db0f3c43.png";